export default __webpack_public_path__ + "static/media/January2018.d726b719.png";